import { Col, Row, Text } from 'components';
import { currencies, formatLocale, theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 936px;
  padding: 0 24px;
  height: 66px;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid ${theme.GREY_20};

  @media (max-width: 1024px) {
    width: calc(100vw - 32px);
    margin: 0 16px;
    padding: 0;
    height: unset;
    flex-direction: column;
  }
`;

const HistoryItem = ({ item }) => {
  const { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState),
    user = useSelector((state) => state.user),
    currency =
      currencies.find((x) => x.value.toLowerCase() === item?.currency) ||
      currencies.find((x) => x.value === 'USD');

  if (!currency) return null;

  function getDesc() {
    switch (item.type) {
      case 'shoutout':
        return t('billing.shoutoutTo', { name: item.name });
      case 'connectRequest':
        return t('billing.connectWith', { name: item.name });
      case 'connectRefused':
        return t('billing.connectRefused', { name: item.name });
      case 'connectCanceledByFan':
        return t('billing.connectCanceledBy', { name: user.name });
      case 'connectCanceledByAthlete':
        return t('billing.connectCanceledBy', { name: item.name });
      case 'subscription':
        return t('billing.subscription', { name: item.name });
      case 'order':
        return t('billing.productOrder');
      default:
        return '';
    }
  }

  return (
    <Container>
      {!isMobile ? (
        <React.Fragment>
          <Text b2 wid="136px">
            {formatLocale(new Date(item.createdAt), 'MMM d, yyyy')}
          </Text>

          <Text b2 wid="376px">
            {getDesc()}
          </Text>

          <Text b2 wid="192px" marg="0 0 0 73px">
            {item.last4 ? `**** ${item.last4}` : ''}
          </Text>

          <Text bold b2 marg="0 0 0 90px">
            {currency.symbol}
            {(item.amount / (currency.value === 'JPY' ? 1 : 100)).toFixed(2)}
          </Text>
        </React.Fragment>
      ) : (
        <Col wid="calc(100% - 32px)" pad="16px">
          <Row between wid="100%" noFlex>
            <Text b2>{formatLocale(new Date(item.createdAt), 'MMM d, yyyy')}</Text>

            <Text b2 bold>
              {currency.symbol}
              {(item.amount / (currency.value === 'JPY' ? 1 : 100)).toFixed(2)}
            </Text>
          </Row>

          <Text b2 marg="16px 0 0">
            {getDesc()}
          </Text>

          <Text b2 marg="8px 0 0">
            {item.last4 ? `**** ${item.last4}` : ''}
          </Text>
        </Col>
      )}
    </Container>
  );
};

export default HistoryItem;
